<template>
  <div
    id="modview__info-modal"
    ref="modalContainer"
    class="modal fade"
    aria-labelledby="modview__info-modal"
    aria-hidden="true"
    role="dialog"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div v-if="item != null" class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="btn btn-icon position-absolute top-0 end-0 mt-2 me-2"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <fa-icon class="text-rhino" :icon="faTimes" />
          </button>
        </div>
        <div class="modal-body">
          <div class="d-flex">
            <landing-page-modview-grid-mod-icon class="d-block" :item="item" />
            <div class="position-relative ms-4 pe-8 flex-grow-1">
              <b>{{ item.name }}</b>
              <p class="text-primary mb-0">{{ recommendedRamSize }}</p>

              <landing-page-modview-grid-mod-tags
                class="mt-2"
                :tags="item.tags"
              />
            </div>
          </div>
          <p class="mb-0 mt-4">{{ item.description }}</p>
        </div>
        <div class="modal-footer justify-content-center">
          <a
            :href="item.orderUrl"
            class="btn btn-sm btn-primary col-12 col-md-auto"
            data-cy="order-now-btn"
          >
            {{ $t('frontend/order-now') }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import type { StrapiMinecraftModpack } from '~/apollo/types/types';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import useBootstrapModal from '~/composables/bootstrap/useModal';

export default defineComponent({
  props: {
    item: {
      type: Object as PropType<StrapiMinecraftModpack>,
      default: null,
    },
  },
  emits: ['modal-closed'],
  setup(props, { emit }) {
    const { t } = useI18n();
    const recommendedRamSize = computed(() =>
      t('general/ram/units/recommended', {
        units:
          props.item.unit === 'MB'
            ? props.item.memory / 1024
            : props.item.memory,
        unitName: 'GB',
      }),
    );

    const modalContainer = ref<HTMLElement>(null);

    const { closeModal, openModal } = useBootstrapModal(modalContainer, () =>
      emit('modal-closed'),
    );

    watch(
      () => props.item,
      (newValue) => {
        if (newValue != null) {
          openModal();
        } else {
          closeModal();
        }
      },
    );

    return {
      faTimes,

      modalContainer,
      recommendedRamSize,
    };
  },
});
</script>

<style scoped lang="scss">
@import 'gportal-theme/scss/_colors.scss';

.modview__grid-item {
  background: $gp-midnight-2;
  text-transform: capitalize;
}
</style>
